import { Avatar } from '@mui/material';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { getCalendarEventDetails } from '../services/apiCalls';
export default function CalendarEventDetails(_ref) {
    var request = _ref.request;
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: 'customer-details',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Custom,
                    name: '',
                    value: null,
                    columnSize: 0,
                    element: function () { /*#__PURE__*/ return React.createElement(Avatar, null); }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    value: null,
                    columnSize: true,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'CustomerName',
                            value: '-',
                            fontWeight: 'medium',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            value: '-',
                            name: 'Mobile',
                            color: 'secondary',
                            fontSize: 'sm',
                            columnSize: 12
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: 'vehicle-details',
                    columnSize: 12,
                    contentProps: {
                        spacing: 0.5
                    },
                    sx: {
                        p: 1.5,
                        bgcolor: 'secondary.50',
                        border: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            label: 'Scheduled Date & Time :',
                            name: 'AppointmentDate',
                            value: '-',
                            columnSize: 12,
                            fontWeight: 'medium',
                            containerProps: {
                                container: true,
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            labelTypographyProps: {
                                mb: 0
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            label: 'Registration No.:',
                            name: 'RegNo',
                            value: '-',
                            columnSize: 12,
                            fontWeight: 'medium',
                            containerProps: {
                                container: true,
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            labelTypographyProps: {
                                mb: 0
                            }
                        },
                        // {
                        //     type: FormItemTypes.Typography,
                        //     label: 'Chassis No. :',
                        //     name: 'ChassisNo',
                        //     value: '-',
                        //     columnSize: 12,
                        //     fontWeight: 'medium',
                        //     containerProps: {
                        //         container: true,
                        //         flexDirection: 'row',
                        //         justifyContent: 'space-between',
                        //         alignItems: 'center'
                        //     },
                        //     labelTypographyProps: { mb: 0 }
                        // },
                        {
                            type: FormItemTypes.Typography,
                            label: 'Vehicle :',
                            name: 'ProductModel',
                            value: '-',
                            columnSize: 12,
                            fontWeight: 'medium',
                            containerProps: {
                                container: true,
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            },
                            labelTypographyProps: {
                                mb: 0
                            }
                        }]
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    columnSize: 12,
                    fullWidth: true,
                    children: 'View details',
                    variant: 'outlined'
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        getFormAPI: getCalendarEventDetails
        // getKey={CRMCalendarKeys.eventDetails}
        ,
        getRequest: request
    });
}
